import { Language } from '@evimo/types/enums/language';
import { CountryCode } from '@evimo/types/enums/country-code';

export const useMapLanguageToCountry = (language: Language): CountryCode => {
  switch (language) {
    case Language.EN:
      return CountryCode.US;
    case Language.FR:
      return CountryCode.FR;
    default:
      return CountryCode.US;
  }
};

export const useMapCountryToLanguage = (country: CountryCode): Language => {
  switch (country) {
    case CountryCode.US:
    case CountryCode.GB:
      return Language.EN;
    case CountryCode.FR:
      return Language.FR;
    default:
      return Language.EN;
  }
};
